// extracted by mini-css-extract-plugin
module.exports =  {"content":"a10a3f92e9--content--VcYgJ","icon-wrapper":"a10a3f92e9--icon-wrapper--G5Ra7","heading":"a10a3f92e9--heading--vl9QP","footer":"a10a3f92e9--footer--veeUl"};